import React from 'react';
// import make from '../../images/integrations/make.svg';
import make from '../../images/integrations/make.png';
import IntegrationBot from '../../components/integrationn/index';

const Integromat = () => <IntegrationBot botLogo={make} botName={'Make, formerly Integromat'} />;

export default Integromat;
